import { render, staticRenderFns } from "./RemolqueEstado.vue?vue&type=template&id=6bdb066e"
import script from "./RemolqueEstado.vue?vue&type=script&lang=js"
export * from "./RemolqueEstado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports